import {registerCustomHook} from "../lib/core";
import {store} from "../lib/store";
import {CONFIG} from "./config";

//Custom loading hooks
export const initCustomHooks = () => {
	//registerCustomHook('onNotFoundLoadingPage', (params) => {});
	//registerCustomHook('onBeforeEvaluatingPage', (params) => {});

    registerCustomHook('onBeforeLoadingPage', (params) => {


        if (CONFIG.cachePages > 0 && store.getState().pageState.previous.map(prev => prev.page?.slug).indexOf(params.search) >= 0) {
            let index = store.getState().pageState.previous.map(prev => prev.page?.slug).indexOf(params.search);
            store.dispatch({
                type: 'PAGE_LOADED',
                page: store.getState().pageState.previous[index].page,
                head: store.getState().pageState.previous[index].head
            })
            return false;
        }

        if (params.args.params.page === 'search') {

            params.page.title = 'Search | WIRA ICME';
            params.page.slug = 'search';
            params.page.template = 'search';

            params.dispatch({
                type: 'PAGE_LOADED',
                page: params.page,
                head: {
                    title: params.page.title
                }
            })

            return false;
        }

        return true;

    });

	//registerCustomHook('onSuccessLoadingPage', (params) => {});
	//registerCustomHook('onSettingsLoaded', (params) => {});
    //registerCustomHook('onComponentCookieAccept', (accepted) => {});
    //registerCustomHook('modifySearchSlug', (params) => { return true; });
};



